import { DataResponseMapper, Mapper, MapperCreateRequest, MapperSearchRequest, MapperUpdateRequest } from "@bluefalcon/clients-management-client-fetch";
import { falconClients } from "../clients/falcon.client";

export class MappersService {

    async createMapper(request: MapperCreateRequest): Promise<Mapper> {
        return falconClients.mappers.createMapper({
            mapperCreateRequest: request,
        });
    }

    async searchMappers(options?: MapperSearchRequest): Promise<DataResponseMapper> {
        return falconClients.mappers.searchMappers({
            mapperSearchRequest: options ?? {},
        });
    }

    async getMapperById(id: number): Promise<Mapper> {
        return falconClients.mappers.getMapperById({
            id,
        });
    }

    async updateMapper(id: number, request: MapperUpdateRequest): Promise<Mapper> {
        return falconClients.mappers.updateMapperById({
            id,
            mapperUpdateRequest: request,
        });
    }
}
